<script>
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ListGroup,
    ListGroupItem,
    Input
  } from "sveltestrap";
  import { createEventDispatcher, getContext } from "svelte";
  import { Spinner } from "sveltestrap";
  export let date;
  export let open;
  export let toggle;
  export let staffid;
  import Icon from "svelte-awesome";
  import { refresh } from "svelte-awesome/icons";
  import axios from "axios";
  let job = "";
  let deliverable = null;
  let task = null;
  let taskArray = null;
  let monday = 0;
  let tuesday = 0;
  let wednesday = 0;
  let thursday = 0;
  let friday = 0;
  let saturday = 0;
  let sunday = 0;
  let jobsArray = null;
  let deliverableArray = null;
  let job_id = "";
  let focus = true;
  let showDeliverable = false;
  let completed = false;
  let submitting = false;
  let error = false;
  let error_message = "";
  let error_all = false;
  let fetching_job = false;
  let error_monday = false;
  let error_tuesday = false;
  let monday_show = false;
  let tuesday_show = false;
  let wednesday_show = false;
  let thursday_show = false;
  let friday_show = false;
  let saturday_show = false;
  let sunday_show = false;
  let monday_note = "";
  let tuesday_note = "";
  let wednesday_note = "";
  let thursday_note = "";
  let friday_note = "";
  let saturday_note = "";
  let sunday_note = "";
  let refreshButton = false;

  let { getCurrentTimesheetId, refreshTimesheet } = getContext('timesheet');

  async function getJobs(job) {
    fetching_job = true;
    const res = await fetch("/timesheetapi/BuildJob?prefixText=" + job);
    const json = await res.json();
    fetching_job = false;
    jobsArray = json;
  }

  async function getDeliverable(job_id) {
    const res = await fetch("/timesheetapi/BuildDeliverables?jobId=" + job_id);
    const json = await res.json();
    deliverableArray = json;
  }

  async function getTask(deliverable_id) {
    const res = await fetch(
      "/timesheetapi/BuildCostCenter?deliverableId=" + deliverable_id
    );
    const json = await res.json();
    taskArray = json;
  }

  function refreshJoblist() {
    refreshButton = true;

    axios
      .get("/timesheetapi/RefreshJobList")
      .then(function(res) {
        refreshButton = false;
      })
      .catch(function(err) {
        console.log(err);
      });
  }
  async function submitNewtimesheet() {
    submitting = true;
    const data = {
      JobId: job_id,
      JobName: job,
      TimesheetId: getCurrentTimesheetId(),
      DeliverableId: deliverable,
      TaskId: task,
      SundayHours: sunday,
      SaturdayHours: saturday,
      FridayHours: friday,
      ThursdayHours: thursday,
      WednesdayHours: wednesday,
      TuesdayHours: tuesday,
      MondayHours: monday,
      CheckCompleted: completed,
      weekStart: date,
      StaffId: staffid,
      MondayNotes: monday_note,
      TuesdayNotes: tuesday_note,
      WednesdayNotes: wednesday_note,
      ThursdayNotes: thursday_note,
      FridayNotes: friday_note,
      SaturdayNotes: saturday_note,
      SundayNotes: sunday_note
    };
    const res = await fetch("/timesheetapi/savetimecard", {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(data)
    });
    const json = await res.status;
    submitting = false;
    job = "";
    deliverable = null;
    task = "";
    taskArray = null;
    monday = 0;
    tuesday = 0;
    wednesday = 0;
    thursday = 0;
    friday = 0;
    saturday = 0;
    sunday = 0;
    jobsArray = null;
    deliverableArray = null;
    job_id = "";
    focus = true;
    showDeliverable = false;
    completed = false;
    monday_note = "";
    tuesday_note = "";
    wednesday_note = "";
    thursday_note = "";
    friday_note = "";
    saturday_note = "";
    sunday_note = "";
    toggle();
    if (json === 200) {
      setTimeout(() => {
        refreshTimesheet();
        submitting = false;
      }, 100);
    }
  }

  function handleChangeJob(e) {
    job = e.target.value;
    getJobs(job);
  }

  function handlePassId(id, name) {
    focus = false;
    job_id = id;
    job = name;
    showDeliverable = true;
    getDeliverable(id);
  }

  function handleChangeDeliverable(e) {
    deliverable = e.target.value;
    getTask(deliverable);
  }

  function handleChangeTask(e) {
    task = e.target.value;
    console.log(task);
  }

  const onFocus = () => (focus = true);

  function handleSubmit() {
    if (job === "") {
      error = true;
      error_message = "Failed! Fields must not be empty except (optional)";
    } else if (deliverable === "" || deliverable === null) {
      error = true;
      error_message = "Failed! Fields must not be empty except (optional)";
    } else if (task === "" || task === null || task === " ") {
      error = true;
      error_message = "Failed! Fields must not be empty except (optional)";
    } else if (
      monday === 0 &&
      tuesday === 0 &&
      wednesday === 0 &&
      thursday === 0 &&
      friday === 0 &&
      saturday === 0 &&
      sunday === 0
    ) {
      error = true;
      error_message = "Failed! You must atleast add time in any day.";
    } else if (
      monday > 24 ||
      tuesday > 24 ||
      wednesday > 24 ||
      thursday > 24 ||
      friday > 24 ||
      saturday > 24 ||
      sunday > 24
    ) {
      error = true;
      error_message = "Hours Should not exceed to 24";
    } else {
      error = false;
      submitNewtimesheet();
    }
  }

  function handleCancel() {
    toggle();
    job = "";
    deliverable = null;
    task = "";
    taskArray = null;
    jobsArray = null;
    deliverableArray = null;
    job_id = "";
    focus = true;
    showDeliverable = false;
    completed = false;
    error = false;
    monday_show = false;
    tuesday_show = false;
    wednesday_show = false;
    thursday_show = false;
    friday_show = false;
    saturday_show = false;
    sunday_show = false;
  }
</script>

<style>
  label {
    font-size: 18px;
    display: inline-block;
    font-weight: 500;
  }
  .btn-show-note {
    background-color: white;
    color: black;
    border: 1px solid #b2bec3;
    padding: 0px 10px;
    border-radius: 5px;
    float: right;
  }
  select {
    width: 100%;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }
  input {
    width: 100%;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }
  .row-container {
    margin: 25px 0px;
  }
  select:disabled {
    background-color: #f1f2f6;
    cursor: not-allowed;
  }
  .listgroup-style {
    overflow-y: scroll;
    max-height: 400px;
    position: absolute;
    border: 1px solid #4bcffa;
  }
  .listgroup-style::-webkit-scrollbar {
    display: none;
  }
  .listitem-style {
    width: auto;
    max-width: 465.5px;
    min-width: 465.5px;
  }
  input:focus{
        border: 2px solid #706c6c;
  }
</style>

<Modal isOpen={open} {toggle}>
  <ModalHeader {toggle}>+Add New Timesheet</ModalHeader>
  <ModalBody>
    <div class="newtimesheet-modal-body">
      <div class="row-container">
        <span>
          <label>Job</label>
          <button on:click={refreshJoblist} disabled={refreshButton}>
            <Icon data={refresh} />
          </button>
        </span>
        <input
          type="text"
          placeholder="Jobs"
          value={job}
          on:keyup={handleChangeJob}
          on:focus={onFocus}
          autofocus />
        {#if fetching_job}
          <Spinner
            size="sm"
            style="position: absolute; margin-left: -23px; margin-top: 15px;
            color: #b2bec3" />
        {/if}
        <input type="text" value={job_id} hidden />
        {#if jobsArray !== null}
          {#if job !== ''}
            {#if focus}
              <div class="listgroup-style">
                <ListGroup>
                  {#each jobsArray as job}
                    <div class="listitem-style">
                      <ListGroupItem
                        tag="button"
                        action
                        key={job.jobId}
                        on:click={handlePassId(job.jobId, job.jobName)}
                        style="text-align:left">
                        {job.jobName}
                      </ListGroupItem>
                    </div>
                  {/each}
                </ListGroup>
              </div>
            {/if}
          {/if}
        {/if}
      </div>
      <div class="row-container">
        <label>Deliverable</label>
        {#if job !== ''}
          <select
            value={deliverable}
            on:change={handleChangeDeliverable}
            style={showDeliverable ? '' : 'cursor: not-allowed;'}>
            {#if deliverableArray !== null}
              {#each deliverableArray as deliverable}
                <option value={deliverable.deId}>{deliverable.deName}</option>
              {/each}
            {/if}
          </select>
        {:else}
          <select>
            <option>-----</option>
          </select>
        {/if}
      </div>
      <div class="row-container">
        <label>Task</label>
        {#if deliverable !== null}
          <select
            value={task}
            on:change={handleChangeTask}
            disabled={showDeliverable ? false : true}>
            {#if taskArray !== null}
              {#each taskArray as task}
                <option value={task.costId}>{task.costName}</option>
              {/each}
            {/if}
          </select>
        {:else}
          <select>
            <option>-----</option>
          </select>
        {/if}
      </div>
      <div class="row-container">
        <label>Monday</label>
        <button
          class="btn-show-note"
          on:click={() => (monday_show = !monday_show)}>
          {monday_show ? '- Hide Note' : '+ Add Note'}
        </button>
        <input type="number" placeholder="Monday" bind:value={monday} />
        {#if monday_show}
          <Input
            type="textarea"
            placeholder="Monday Notes (Optional)"
            style="margin-top: 13px;"
            bind:value={monday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Tuesday</label>
        <button
          class="btn-show-note"
          on:click={() => (tuesday_show = !tuesday_show)}>
          {tuesday_show ? '- Hide Note' : '+ Add Note'}
        </button>
        <input type="number" placeholder="Tue" bind:value={tuesday} />
        {#if tuesday_show}
          <Input
            type="textarea"
            placeholder="Tuesday Notes (Optional)"
            style="margin-top: 13px;"
            bind:value={tuesday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Wednesday</label>
        <button
          class="btn-show-note"
          on:click={() => (wednesday_show = !wednesday_show)}>
          {wednesday_show ? '- Hide Note' : '+ Add Note'}
        </button>
        <input type="number" placeholder="Wed" bind:value={wednesday} />
        {#if wednesday_show}
          <Input
            type="textarea"
            placeholder="Wednesday Notes (Optional)"
            style="margin-top: 13px;"
            bind:value={wednesday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Thursday</label>
        <button
          class="btn-show-note"
          on:click={() => (thursday_show = !thursday_show)}>
          {thursday_show ? '- Hide Note' : '+ Add Note'}
        </button>
        <input type="number" placeholder="Thu" bind:value={thursday} />
        {#if thursday_show}
          <Input
            type="textarea"
            placeholder="Thursday Notes (Optional)"
            style="margin-top: 13px;"
            bind:value={thursday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Friday</label>
        <button
          class="btn-show-note"
          on:click={() => (friday_show = !friday_show)}>
          {friday_show ? '- Hide Note' : '+ Add Note'}
        </button>
        <input type="number" placeholder="Fri" bind:value={friday} />
        {#if friday_show}
          <Input
            type="textarea"
            placeholder="Friday Notes (Optional)"
            style="margin-top: 13px;"
            bind:value={friday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Saturday</label>
        <button
          class="btn-show-note"
          on:click={() => (saturday_show = !saturday_show)}>
          {saturday_show ? '- Hide Note' : '+ Add Note'}
        </button>
        <input type="number" placeholder="Sat" bind:value={saturday} />
        {#if saturday_show}
          <Input
            type="textarea"
            placeholder="Saturday Notes (Optional)"
            style="margin-top: 13px;"
            bind:value={saturday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Sunday</label>
        <button
          class="btn-show-note"
          on:click={() => (sunday_show = !sunday_show)}>
          {sunday_show ? '- Hide Note' : '+ Add Note'}
        </button>
        <input type="number" ys placeholder="Sun" bind:value={sunday} />
        {#if sunday_show}
          <Input
            type="textarea"
            placeholder="Sunday Notes (Optional)"
            style="margin-top: 13px;"
            bind:value={sunday_note} />
        {/if}
      </div>
      {#if error}
        <div
          class="row-container"
          style="text-align:center; background-color: #eb4d4b; color: white;">
          <p>{error_message}</p>
        </div>
      {/if}
    </div>
  </ModalBody>
  <ModalFooter>
    {#if submitting}
      <Button
        color="primary"
        style="cursor: not-allowed; opacity: 0.5"
        on:click={handleSubmit}
        disabled>
        <Spinner size="sm" />
        Saving
      </Button>
    {:else}
      <Button color="primary" on:click={handleSubmit}>Save</Button>
    {/if}
    <Button color="secondary" on:click={handleCancel}>Cancel</Button>
  </ModalFooter>
</Modal>
